
import GwInlineNavigationItem from './inline-navigation-item';
import GwInlineNavigation from '~/patterns/molecules/inline-navigation/inline-navigation.vue';

export default {
    components: {
        GwInlineNavigation,
        GwInlineNavigationItem,
    },
    props: {
        children: {
            type: Array,
            required: true,
            default: () => { return []; }
        },
    },
    data() {
        return {
            activeItem: null
        };
    },
    methods: {
        viewHandler(event) {
            if (event.percentInView > 0.8) {
                this.activeItem = event.target.element.id;
            }
        }
    }
};
